export default __webpack_public_path__ + "1e220ad0aeae0a5553f79549195521e2.webp";